import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";
import { FilterKey } from "@studyportals/search-filters";

export class Continent extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const singleContinentSelected = await this.singleSelectionFor(FilterKey.CONTINENT, filterSelectionState);
		const continentSelected = await this.selectionOnlyFor([FilterKey.CONTINENT], filterSelectionState);

		return metaRankingSortSelected && singleContinentSelected && continentSelected;
	}

	protected selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const continent = this.getFilterOptionNameBy(FilterKey.CONTINENT, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Top universities in ${continent} ${year} | SP Meta Ranking`,

			description:
				`Check out our ${continent} university rankings for ${year}, ` +
				`merging the most popular ranking sources to create this list ` +
				`of the top universities in ${continent}.`
		};

		return Promise.resolve(seoInfo);
	}
}
